import { Company, Role } from "@vviinn/user-managment-client-ts";

export const findCompanyMemberRole = (
  company: Pick<Company, "owners" | "members">,
  userId?: string,
): Role | undefined => {
  if (company.owners?.some((owner) => owner.id === userId)) return "owner";
  return company.members?.find((member) => member.id === userId)?.role as Role;
};
